import { Button } from '@ps/isp-web-component-library';
import { CashierPath } from '@ps/web-pam-types';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useNavigate, useTrackingLabel } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import {
  TXTWCL_Join,
  TXTWCL_Log_in_or_join_to_watch_live,
  TXTWCL_Login
} from './LoginForm.messages.json';
import styles from './LoginForm.scss';

const LoginForm: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { buttonPressed } = useTrackers();
  const loginButtonName = useTrackingLabel(TXTWCL_Login);
  const joinButtonName = useTrackingLabel(TXTWCL_Join);
  const navigate = useNavigate();

  return (
    <div className={styles.loginFormContainer}>
      <div className={styles.loginFormHeading}>
        <Translation {...TXTWCL_Log_in_or_join_to_watch_live} />
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          onClick={() => {
            buttonPressed({ buttonName: loginButtonName });
            modal.enqueue({ path: '/auth/login' });
          }}
          size="medium"
          variant="secondary"
          className={styles.loginButton}
        >
          <Translation {...TXTWCL_Login} />
        </Button>
        <Button
          onClick={() => {
            buttonPressed({ buttonName: joinButtonName });
            navigate(CashierPath.Signup);
          }}
          size="medium"
        >
          <Translation {...TXTWCL_Join} />
        </Button>
      </div>
    </div>
  );
};

export default LoginForm;
